<div class="apmt-event-wrap-merged">
  <div class="middle">
    <div class="desc">
      <span class="attendance"><img class="icon" src="assets/images/calendar_icon_06.png">출석완료</span>
    </div>
  </div>
</div>
